var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagTun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 19,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 1H1V19H28V1Z",
    fill: "url(#paint0_linear_245_12916)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5015 15.2799C17.4178 15.2799 19.7814 12.9158 19.7814 10.0001C19.7814 7.08436 17.4172 4.72021 14.5015 4.72021C11.5853 4.72021 9.22168 7.08436 9.22168 10.0001C9.22168 12.9158 11.5853 15.2799 14.5015 15.2799ZM15.9165 10.9224L14.9072 12.327L14.898 10.5974L13.2502 10.0716L14.8923 9.52861L14.8832 7.79898L15.9073 9.19275L17.5494 8.64978L16.5401 10.0544L17.5643 11.4488L15.9165 10.9224ZM14.5433 6.0562C15.6922 6.0562 16.7266 6.54024 17.4573 7.31494C16.9526 6.99339 16.3542 6.80686 15.7116 6.80686C13.9134 6.80686 12.4555 8.26472 12.4555 10.063C12.4555 11.8613 13.9134 13.3191 15.7116 13.3191C16.3542 13.3191 16.9526 13.132 17.4573 12.8111C16.7266 13.5852 15.6916 14.0698 14.5433 14.0698C12.3308 14.0698 10.5365 12.2761 10.5365 10.063C10.5365 7.8499 12.3302 6.0562 14.5433 6.0562Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_12916",
    x1: 1,
    y1: 9.99991,
    x2: 27.9997,
    y2: 9.99991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTun);
export default __webpack_public_path__ + "static/media/flagTUN.c7fd618f303a5a5f873415fb85fdb820.svg";
export { ForwardRef as ReactComponent };